import React from 'react'
import './ProfileDetail.scss'
import SectionHeader from "../../component/SectionHeader/SectionHeader";
import {Zoom,Slide} from "react-reveal";

import BottomNav from "../../component/BottomNav/BottomNav";
import StockList from "../../component/StockListing/StockList";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import {Fade} from 'react-reveal'
import {connect} from "react-redux";
import {MDBIcon} from "mdbreact";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";
import {setActivePage} from "../../Actions";
import UsersStatisticsQuery from "../../queries/UsersStatisticsQuery";
import PortfolioCurrentHoldingQuery from "../../queries/PortfolioCurrentHoldingQuery";
import Loading from "../../component/Loading";
import SubPageHeader from "../../component/SubPageHeader/SubPageHeader";
import dateFormat from "dateformat";
import {NonEmptyArray, numberFormat} from "../../util";
import StockOwnedCountQuery from "../../queries/StockOwnedCountQuery";
import StockHistoryDetailsQuery from "../../queries/StockHistoryDetailsQuery";

const profileConfetti = assetUrl+"images/Confetti_Leaderboard.svg";
const curvePath = assetUrl+'images/leaderboard_profile_card_bg.png'
const chart = assetUrl+'images/chart_leaderboard_detail.png'
const cup = assetUrl+'images/cup_leaderboard_detail.png'
const particles = assetUrl+'images/leaderboard_profile_bg_pattern.svg'
const particles2 = assetUrl+'images/profile-detail-blueDot.svg'
const stats = assetUrl+'images/icon_Statistics1.svg'
const invest = assetUrl+'images/icon_Investment1.svg'
const Greenarrow = assetUrl+'images/leaderboard_detail_growth1.png'
const Redarrow = assetUrl+'images/leaderboard_detail_loss1.png'

class ProfileDetail extends React.Component{
	state = {
		usersStatistics:{},
		currentHoldings:[],
		stockOwnedCount:{},
		stockHistoryDetails:[],
		loadingArray: ["loading"]
	}
	componentDidMount() {
		this.props.setActivePage("chart");
		if(this.props.logged_in){
			this.getUserStatistics();
			this.getCurrentHoldings();
			this.getStockOwnedCount();
		}

		this.getStockHistoryDetails();
	}

	getUserStatistics = () => {
		let variables = {
			userId:this.props.profile_data.user_id
		}
		this.updateLoading(true);
		fetchQuery(environment, UsersStatisticsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.usersStatistics !== null) {
					this.setState({
						usersStatistics:response.usersStatistics
					});
				} else {
					this.setState({
						usersStatistics:{}
					});
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					usersStatistics:{}
				});

			});
	}
	getStockHistoryDetails = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockHistoryDetailsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);


				if (  response.stockHistoryDetails !== null && Object.keys(response.stockHistoryDetails).length > 0) {


					this.setState({
						stockHistoryDetails:  response.stockHistoryDetails
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.stockHistoryDetails.price_diff)
				} else {
					this.setState({
						stockHistoryDetails: []

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockHistoryDetails: []
				})
			});
	}
	getStockOwnedCount = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockOwnedCountQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.stockOwnedCount !== null && Object.keys(response.stockOwnedCount).length > 0) {
					this.setState({
						stockOwnedCount: response.stockOwnedCount
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stockOwnedCount: {}

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockOwnedCount: {}
				})
			});
	}

	getCurrentHoldings = () => {
		let variable = {
			userId:this.props.profile_data.user_id
		}
		this.updateLoading(true);
		fetchQuery(environment, PortfolioCurrentHoldingQuery, variable)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.userCurrentHoldings) ) {
					this.setState({
						currentHoldings: this.formateStockData(response.userCurrentHoldings.edges)
					});
				} else {
					this.setState({
						currentHoldings: []
					});
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					currentHoldings: []
				});
			});
	}

	updateLoading = (action) => {
		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}
		this.setState({
			loadingArray: tmp_loading_array
		})
	}


	getFormateDate = (date) => {
		const now = new Date(date);
		let formated_date = dateFormat(now, "d mmm,yyyy");
		return formated_date;
	}
	formateStockData = (response) => {
		let stockList = [];
		let res_data = response;
		for (var i = 0; i < res_data.length; i++) {
			let tmp_stock = res_data[i].node.stock;
			stockList[i] = {
				id: tmp_stock.id,
				name: tmp_stock.name,
				party_name: tmp_stock.party.partyName,
				price: tmp_stock.price,
				// stockOwned change
				// stocks_owned: tmp_stock.stockOwnedCount,
				price_diffrence: tmp_stock.priceDiff,
				politicianImage: tmp_stock.politicianImage
			}
		}
		return stockList;
	}

	render() {
		const {usersStatistics} = this.state;
		const {profile_data} = this.props;
		return (
			<Loading loading={this.state.loadingArray.length > 1}>
				<div className={"profile-detail"}>
				<SubPageHeader title={"Profile"} show_action={true}/>
				<div className={'container py-2 px-4'}>
					{/* card    */}
					<div className={"profile-card my-2 "}>
						<img alt="alt" src={curvePath} className={"curve-image"}/>
						<div className={'bg-particles'}><Slide delay={500} bottom ><img src={particles} alt={"akt"} /></Slide></div>
						<div className={'bg-particles-blue'}><Slide delay={500} left ><img src={particles2} alt={"akt"} /></Slide></div>
						<div className={'d-flex mb-4'}>
							<div style={{position: "relative"}} className={'mr-2'}>
								<Zoom delay={500}>
									<div className={"your-card-image"}>
										{
											profile_data.avatar_url ?
												<img src={profile_data.avatar_url} alt={"alt"} className={"your-avatar-pic"}/>
												:
												<p className={"your-avatar-name mb-0"}>{profile_data.short_username && (profile_data.short_username).toUpperCase()}</p>
										}

									</div>
								</Zoom>
								{/*<Zoom delay={500}><img src={profileImage} alt={"alt"}*/}
								{/*					   className={"your-card-image "}/></Zoom>*/}
								<Zoom delay={800}><img src={profileConfetti} alt={"alt"}
													   className={"confetti"}/></Zoom>
							</div>
							<div className={"mx-2"}>
								<p className={"your-name my-1"}>
									{profile_data.user_first}

								</p>
								<p className={"your-account-id py-1 px-2 my-1"}>

									{profile_data.user_first}
								</p>
							</div>
						</div>
						<div className={'d-flex'}>
							<div className={"d-flex align-items-center mr-4"}>
								<img src={chart} alt={"alt"} className={"profile-card-detail-icon my-2 mx-1"}/>
								<div className={" my-1"}>
									<div className={'d-flex mx-1 align-items-center'}>
										<p className={"value my-0 mr-1"}>
											{
												profile_data.newUser === true ? "NILL":(profile_data.growth+"%")
											}
										</p>
										{
											profile_data.growth > 0 ?
												<img alt={"alt"}  src={Greenarrow}   style={{width:"16px",height:"16px",color:profit_color}}/>:
												<img alt={"alt"}  src={Redarrow}  style={{width:"16px",height:"16px",color:loss_color}} />

										}
									</div>
									<p className={"text mx-1 my-1"}>Growth</p>
								</div>
							</div>
							<div className={"d-flex align-items-center ml-0"}>
								<img src={cup} alt={"alt"} className={"profile-card-detail-icon my-2 mx-1"}/>
								<div className={" my-1"}>
									<div className={' mx-1 d-flex align-items-center'}>
										<p className={"value my-0 mr-1"}>
											{
												profile_data.newUser === true ? "NILL":profile_data.place
											}
										</p>
										{
											profile_data.growth > 0 ?
												<img alt={"alt"} src={Greenarrow}   style={{width:"16px",height:"16px",color:profit_color}}/>:
												<img alt={"alt"} src={Redarrow}  style={{width:"16px",height:"16px",color:loss_color}} />


										}
									</div>
									<p className={" mx-1 text my-1"}>Rank</p>
								</div>
							</div>
						</div>
					</div>
					<br/>
					{/*statistics*/}
					{
						this.props.logged_in &&
						<div className={"statistics my-2"}>
							<SectionHeader image={stats} heading={"Statistics"}/>
							<div className={"stats-box my-4 px-3 pt-4 pb-0"}>
								<Fade bottom>
									<div className={'d-flex my-1 justify-content-between'}>
										<p className={"key"}>Joined on</p>
										<p className={"value pr-1"}>{usersStatistics.user?this.getFormateDate(usersStatistics.user.joinedAt):""}</p>
									</div>
								</Fade>
								<Fade bottom>
									<div className={'d-flex my-1 justify-content-between'}>
										<p className={"key"}>Profit / Loss</p>
										<p className={"value pr-1"}>{usersStatistics.profitLoss?numberFormat(usersStatistics.profitLoss):0}</p>
									</div>
								</Fade>
								<Fade bottom>
									<div className={'d-flex my-1 justify-content-between'}>
										<p className={"key"}>Invested</p>
										<p className={"value pr-1"}>{usersStatistics.invested?numberFormat(usersStatistics.invested):0}</p>
									</div>
								</Fade>
								<Fade bottom>
									<div className={'d-flex my-1 justify-content-between'}>
										<p className={"key"}>Current</p>
										<p className={"value pr-1"}>{usersStatistics.marketCurrentTotal?numberFormat(usersStatistics.marketCurrentTotal):0}</p>
									</div>
								</Fade>
								<Fade bottom>
									<div className={'d-flex my-1 justify-content-between'}>
										<p className={"key"}>Bonus</p>
										<p className={"value pr-1"}>{usersStatistics.grantMoney?numberFormat(usersStatistics.grantMoney):0}</p>
									</div>
								</Fade>
							</div>

						</div>
					}


				</div>
				{/*investments*/}
					{
						this.props.logged_in &&
						<div className={"investments my-2"}>
							<SectionHeader image={invest} heading={"Current Investments"} viewmore={false}/>
							<div style={{margin: "25px 0"}}>
								<StockList stock_list={this.state.currentHoldings}
										   stock_history_details={this.state.stockHistoryDetails}
										   stock_owned_count={this.state.stockOwnedCount}/>
							</div>
						</div>
					}
				<div className={"footer"}>
					<BottomNav active_page={"chart"}/>
				</div>
			</div>
			</Loading>
		)
	}
}

const mapStateToProps = state => ({
	profile_data:state.ProfileReducer.profile_data,
	logged_in: state.UserReducer.logged_in

})

const mapDispatchToProps = dispatch => ({

	setActivePage: data => dispatch(setActivePage(data)),
})
export default connect(mapStateToProps,mapDispatchToProps)(ProfileDetail);

